import React, { Suspense, lazy } from 'react';
import './App.css';

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import { AuthProvider } from "./context/AuthContext";
import LandingPage from "./LandingPage";

// Lazy-loaded routes — assets only fetched when the route is visited
const ValentineHome = lazy(() => import("./valentine/Home"));
const ValentineGame = lazy(() => import("./valentine/Game"));
const Bingo         = lazy(() => import("./bingo/Bingo"));
const ProtocolGame  = lazy(() => import("./protocol_v2/ProtocolGameV2"));

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/valentine" element={<ValentineHome />} />
            <Route path="/valentine/game" element={<ValentineGame />} />
            <Route path="/bingo" element={<Bingo />} />
            <Route path="/protocol" element={<ProtocolGame />} />
          </Routes>
        </Suspense>
      </Router>
    </AuthProvider>
  );
};

export default App;